import { AlertOutlined, DoubleRightOutlined } from '@ant-design/icons';
import { ChartGroup, ChartTableLayout, Loading, ECHART_EVENT } from '@meteor/frontend-core';
import { Select, Badge, Tooltip, Tabs, App, Button, message as antdMessage, Modal, Alert } from 'antd';
import { useState, useContext, useEffect, useReducer, useRef, useCallback } from 'react';
import GanttChart from '../components/bryntum-gantt';
import GanttChartWithMp from '../components/bryntum-gantt-with-mp/bryntum-gantt-with-mp';
import DataSwitcher from '../components/data-switcher';
import DateFilteredBarChart from '../components/date-filtered-bar-chart/date-filtered-bar-chart';
import BufferSuitabilityEvaluationChart from '../components/kpi-chart/buffer-suitability-evaluation';
import EvmChart from '../components/kpi-chart/evm';
import PathSuitabilityEvaluationChart from '../components/kpi-chart/path-suitability-evaluation';
import StrategyMatrixCategoryChart from '../components/kpi-chart/strategy-matrix-category';
import StrategyMatrixDistributionChart from '../components/kpi-chart/strategy-matrix-distribution';
import TimelineDisciplineChart from '../components/kpi-chart/timeline-discipline';
import WorkfrontManagement from '../components/kpi-chart/workfront-management';
import BasicInfoCard from '../components/basic-info-card';
import TaskAlert from '../components/task-alert';
import TaskList from '../components/task-list';
import { CHAT_EVENT } from '../consts/chat-event';
import AlertTaskContext from '../contexts/AlertTaskContext';
import { AppContext } from '../contexts/AppContext';
import APIList from '../http/ApiList';
import { useTranslation } from 'react-i18next';
import CriticalChain from '../components/critical-chain';
import domtoimage from 'dom-to-image';
import { jsPDF } from 'jspdf';
import { useNavigate } from 'react-router-dom';
import useGanttFilter from '../hooks/useGantFilter';

const PlanOptionDetailPage: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  // locales
  const { t } = useTranslation();
  const { color, setMenuCollapsed, globalEvent } = useContext(AppContext);
  const {
    dataSection,
    cwaIds,
    disciplineIds,
    setMemoLoading,
    memoSearchValue,
    memoSwitch,
    memoLoading,
    selectOptions,
    importanceCategoryMap,
    sizeMode,
    menuCollapsed,
    scrollCount,
    setScrollCount,
    selectorTop,
  } = useContext(AppContext);
  const [peakOriginData, setPeakOriginData] = useState<any>([]);
  const [peakFilteredData, setPeakFilteredData] = useState<any>([]);
  const [peakData, setPeakData] = useState([]);
  const [currentTab, setCurrentTab] = useState('schedule');
  const [acceptableItems, setAcceptableItems] = useState([]);
  const [notAcceptableItems, setNotAcceptableItems] = useState([]);
  const [messageApi, contextHolder] = antdMessage.useMessage();

  const [chartOption] = useState<any>({
    legend: {
      top: 10,
    },
    grid: {
      left: 80,
      right: 40,
      top: '15%',
    },
    series: [],
  });
  const [alertTaskCollapsed, setAlertTaskCollapsed] = useState(true);
  // const [headerCollapsed, setHeaderCollapsed] = useState(false);
  const [alertView, setAlertView] = useState<any>();
  const [ganttData, setGanttData] = useState<any>();
  const [ganttDataForNewTag, setGanttDataForNewTag] = useState<any>();
  const [optimazeData, setOptimazeData] = useState();
  const [optimizationData, setOptimizationData] = useState<any>();
  const [kpiRoticData, setKpiRoticData] = useState<any>([]);
  const [project, setProject] = useState<any>();
  const [ganttLoading, setGanttLoading] = useState(true);
  const [peakLoading, setPeakLoading] = useState(true);
  const [taskSensitivityLoading, setTaskSensitivityLoading] = useState(true);

  const [alertCount, setAlertCount] = useState(0);
  const [chartLoading, setChartLoading] = useState(true);

  const [selectedTasks, setSelectedTasks] = useState([]);
  const [taskListCollapsed, setTaskListCollapsed] = useState(true);
  const [taskListLoading, setTaskListLoading] = useState(false);
  const [bufferSuitabilityEvaluationData, setBufferSuitabilityEvaluationData] = useState([]);
  const [pathSuitabilityEvaluationData, setPathSuitabilityEvaluationData] = useState([]);
  const [strategyMatrixCategoryData, setStrategyMatrixCategoryData] = useState<any>([]);
  const [timelineDisciplineData, setTimelineDisciplineData] = useState<any>([]);
  const [strategyMatrixDistributionData, setStrategyMatrixDistributionData] = useState<any>([]);
  const [workfrontManagementData, setWorkfrontManagementData] = useState<any>([]);

  const [kpiRoticLoading, setKpiRoticLoading] = useState<any>(true);
  const [bufferSuitabilityEvaluationLoading, setBufferSuitabilityEvaluationLoading] = useState(true);
  const [pathSuitabilityEvaluationLoading, setPathSuitabilityEvaluationLoading] = useState(true);
  const [strategyMatrixCategoryLoading, setStrategyMatrixCategoryLoading] = useState<any>(true);
  const [timelineDisciplineLoading, setTimelineDisciplineLoading] = useState<any>(true);
  const [strategyMatrixDistributionLoading, setStrategyMatrixDistributionLoading] = useState<any>(true);
  const [workfrontManagementLoading, setWorkfrontManagementLoading] = useState<any>(true);

  const [kpiRangeData, setKpiRangeData] = useState<any>([]);
  const [evmAxis, setEvmAxis] = useState<any>([]);
  const [timelineDisciplineAxis, setTimelineDisciplineAxis] = useState<any>([]);
  const [strategyMatrixDistributionAxis, setStrategyMatrixDistributionAxis] = useState<any>([]);
  const [bufferSuitabilityEvaluationAxis, setBufferSuitabilityEvaluationAxis] = useState<any>([]);
  const [pathSuitabilityEvaluationAxis, setPathSuitabilityEvaluationAxis] = useState<any>([]);
  const [resourceLoadingConstraint, setResourceLoadingConstraint] = useState<any>([]);
  const [resourceType, setResourceType] = useState<any>([]);
  const [area, setArea] = useState<any>([]);

  const [taskListTitle, setTaskListTitle] = useState('');

  const [deadline, setDeadline] = useState<any>();

  const [taskSensitivityData, setTaskSensitivityData] = useState<any>();

  const [calenderOrg, setCalenderOrg] = useState<any[]>();
  const [alertShow, setAlertShow] = useState(false);

  const chartHeight = 240;

  let maxHeight = 500;
  if (typeof window !== 'undefined') {
    maxHeight = window.innerHeight - 525;
  }

  const [mode, modeDispatch] = useReducer(
    (state, action) => {
      const { type, value } = action;
      switch (type) {
        case 'collapsed':
          return {
            viewMode: value ? 'table-only' : 'chart-table',
            layoutViewMode: value ? 'table-only' : 'chart-table',
            headerCollapsed: value,
          };
        case 'showTaskCard':
          return {
            viewMode: 'table-card',
            layoutViewMode: 'table-only',
            headerCollapsed: true,
          };
        case 'closeTaskCard':
          return {
            viewMode: 'chart-table',
            layoutViewMode: 'chart-table',
            headerCollapsed: false,
          };
        case 'table-mp':
          return {
            viewMode: 'table-only',
            layoutViewMode: 'table-only',
            headerCollapsed: false,
          };
      }
      return state;
    },
    {
      viewMode: 'chart-table',
      layoutViewMode: 'chart-table',
      headerCollapsed: false,
    },
  );
  const exportContainerRef = useRef<HTMLDivElement>(null);
  const handleExportPDF = async () => {
    const key = 'handleExportPDF';
    messageApi.open({
      key,
      type: 'loading',
      content: '画像保存中、少々お待ちください。',
      duration: 0,
    });
    setTimeout(async () => {
      if (!exportContainerRef.current) {
        return;
      }
      try {
        const dataUrl = await domtoimage.toPng(exportContainerRef.current, {
          quality: 1,
          bgcolor: '#fff',
          style: {
            transform: 'none',
          },
        });

        const pdf = new jsPDF('l', 'mm', 'a2');
        const imgProps = pdf.getImageProperties(dataUrl);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(dataUrl, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`${new Date().toLocaleString().replace(/[/:]/g, '-')}.pdf`);
        message.success({ content: '画像保存完了。' });
        messageApi.open({
          key,
          type: 'success',
          content: '画像保存完了。',
          duration: 2,
        });
      } catch (error) {
        messageApi.open({
          key,
          type: 'error',
          content: '画像保存エラーが発生しました。',
          duration: 2,
        });
      }
    }, 500);
  };
  const handleExport = () => {
    const key = 'handleExport';
    messageApi.open({
      key,
      type: 'loading',
      content: '画像保存中、少々お待ちください。',
      duration: 0,
    });

    setTimeout(() => {
      if (!exportContainerRef.current) {
        return;
      }
      domtoimage
        .toPng(exportContainerRef.current, {
          quality: 1,
          bgcolor: '#fff',
          style: {
            transform: 'none',
          },
        })
        .then((dataUrl) => {
          const link = document.createElement('a');
          link.download = `${new Date().toLocaleString()}.png`;
          link.href = dataUrl;
          link.click();
          messageApi.open({
            key,
            type: 'success',
            content: '画像保存完了。',
            duration: 2,
          });
        })
        .catch((error) => {
          messageApi.open({
            key,
            type: 'error',
            content: '画像保存エラーが発生しました。',
            duration: 2,
          });
        });
    }, 500);
  };

  /**
   * Table高度Map
   */
  const tableHeightMap = {
    'chart-table': maxHeight,
    'table-only': maxHeight + 280,
    'table-card': maxHeight,
  };

  const tableTop = 0;
  const tableWidth = 300;
  const alertAction = (item) => {
    setCurrentTab('schedule');
    setAlertView({
      key: item.title,
      tab: 'schedule',
    });
  };
  const scheduleLink = (item) => {
    const period = item.title;
    const { start, end } = getStartAndEndDates(period);
    setCurrentTab('schedule');
    setAlertView({
      key: item.key,
      tab: 'schedule',
      zoom: true,
      startDate: start,
      endDate: end,
    });
  };
  const mpLink = () => {
    setCurrentTab('peak');
    setTimeout(() => {
      setAlertView({
        seriesName: 'Civil Structure ＆ Architecture',
        index: 1,
        tab: 'peak',
      });
    }, 500);
  };

  const onFilterData = () => {
    // 重新调取接口后，将历史记录清除状态去掉。
    setClearHistory(!dataSection.pageInit);
    modeDispatch({ type: 'closeTaskCard' });
    const { projectId, optimizeId, optimizationId, planId } = dataSection;
    const projectInfo = selectOptions.projects.find((item) => projectId === item.projectId);
    const optimization = selectOptions.optimizations.find((item) => optimizationId === item.optimizationId);
    const plan = selectOptions.plans.find((item) => planId === item.planId);
    const optimize = selectOptions.optimizes.find((item) => optimizeId === item.optimizeId);
    setChartLoading(false);
    if (!optimization) {
      setKpiRoticData([]);
      setKpiRoticLoading(false);
      setBufferSuitabilityEvaluationData([]);
      setBufferSuitabilityEvaluationLoading(false);
      setPathSuitabilityEvaluationData([]);
      setPathSuitabilityEvaluationLoading(false);
      setStrategyMatrixCategoryData([]);
      setStrategyMatrixCategoryLoading(false);
      setStrategyMatrixDistributionData([]);
      setStrategyMatrixDistributionLoading(false);
      setTimelineDisciplineData([]);
      setTimelineDisciplineLoading(false);
      setPeakData([]);
      setPeakLoading(false);
      setGanttData({ tasksData: [] });
      setGanttDataForNewTag({ tasksData: [] });
      setGanttLoading(false);
      return;
    }
    setOptimizationData(optimization);
    setProject(projectInfo);
    setOptimazeData({ ...optimize, planName: plan.planName });
    searchSchedule(optimizationId, optimizeId);
    setCurrentTab('schedule');
    APIList.getKpiValueRange()
      .get({ optimizeId })
      .then((res: any) => {
        setKpiRangeData(res);
        getKpis([optimizationId], projectId, optimizeId);
      })
      .catch(() => {
        message.error('KPI Range Data Error');
      });

    setTaskSensitivityLoading(true);
    APIList.getTaskSensitivity()
      .post({ optimizeId, optimizationId })
      .then((res: any) => {
        setTaskSensitivityLoading(false);
        setTaskSensitivityData(res);
      })
      .catch(() => {
        message.error('KPI Range Data Error');
      });
  };

  const ganttRef = useRef(null);
  const ganttMpRef = useRef(null);
  const [confirmShow, setConfirmShow] = useState(false);
  // gantt 图清空历史记录状态控制
  // 初始化默认为 true, 标记为历史记录已经被清空
  const [clearHistory, setClearHistory] = useState(true);
  useEffect(() => {
    // 如果历史记录状态为 true，则代表两种情况
    // 1. 刚进入页面时，需要初始化拉取数据
    // 2. 用户点击了选择滤器的按钮，需要重新拉取数据
    setClearHistory(!dataSection?.pageInit);
    if (clearHistory && dataSection?.pageInit && selectOptions) {
      onFilterData();
    }
  }, [dataSection, clearHistory]);

  const searchSchedule = (optimizationId: string, optimizeId: string) => {
    setGanttLoading(true);
    APIList.getTaskSchedule()
      .post({ optimizationId })
      // fetch('/task-data.json')
      //   .then((res: any) => {
      //     return res.json();
      //   })
      .then((data: any) => {
        if (data) {
          const { tasksData, dependenciesData, calender } = data;
          setGanttData({ tasksData, dependenciesData });
          setGanttDataForNewTag({ tasksData, dependenciesData });
          setCalenderOrg(calender);
          setTimeout(() => {
            setGanttLoading(false);
          }, 1000);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    setPeakLoading(true);
    APIList.getMpPeak()
      .post({
        optimizationId,
        optimizeId,
        disciplines: disciplineIds,
        cwas: cwaIds,
      })
      // fetch('/mp-data.json')
      //   .then((res: any) => {
      //     return res.json();
      //   })
      .then((res: any) => {
        if (res.list) {
          const data = res.list.map((item) => ({
            seriesName: item[accumulation],
            area: item.area,
            areaName: item.areaName,
            disciplineName: item.disciplineName,
            subDisciplineName: item.subDisciplineName,
            importance: item.importance,
            category: item.category,
            date: new Date(item.date),
            value: item.value,
          }));
          setTimeout(() => {
            setPeakLoading(false);
          }, 1000);
          setPeakOriginData([...data]);
          setPeakFilteredData([...data]);
        }
        if (res.resourceLoadingConstraint) {
          setResourceLoadingConstraint(res.resourceLoadingConstraint);
        }
        if (res.resourceType) {
          setResourceType(res.resourceType);
        }
        if (res.area) {
          setArea(res.area);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    getAlerts(optimizationId);
  };

  const getAlerts = (optimizationId) => {
    setMemoLoading(true);
    APIList.getAlerts()
      .post({
        optimizationId,
        disciplines: disciplineIds,
        cwas: cwaIds,
        hasMemo: memoSwitch,
        memo: memoSearchValue,
      })
      .then((res: any) => {
        const acceptable = makeAlertItems(res.acceptable || []);
        const notAcceptable = makeAlertItems(res.notAcceptable || []);
        setAcceptableItems(acceptable.data);
        setNotAcceptableItems(notAcceptable.data);
        setAlertCount(acceptable.count + notAcceptable.count);
        setMemoLoading(false);
      });
  };

  useEffect(() => {
    if (optimizationData) {
      getAlerts(optimizationData.optimizationId);
    }
  }, [optimizationData, memoSwitch]);

  const makeAlertItems = (alerts) => {
    let count = 0;
    const data = alerts.map((alertItem) => ({
      ...alertItem,
      children: alertItem.children.map((period) => ({
        ...period,
        importanceCategory: importanceCategoryMap[period.importanceCategory],
        scheduleLink,
        mpLink,
        children: period.children.map((task) => {
          count++;
          return {
            ...task,
            scheduleLink: alertAction,
          };
        }),
      })),
    }));
    return {
      data,
      count,
    };
  };

  const getKpis = (optimizationIds, projectId, optimizeId) => {
    setKpiRoticLoading(true);
    APIList.getKpiRotic()
      .post({
        optimizationIds,
        disciplines: disciplineIds,
        cwas: cwaIds,
      })
      .then((res: any) => {
        setKpiRoticData(res);
        setKpiRoticLoading(false);
      });
    setBufferSuitabilityEvaluationLoading(true);
    setPathSuitabilityEvaluationLoading(true);
    setStrategyMatrixCategoryLoading(true);
    setTimelineDisciplineLoading(true);
    setStrategyMatrixDistributionLoading(true);
    setWorkfrontManagementLoading(true);
    APIList.getBufferSuitabilityEvaluation()
      .post({
        optimizationIds,
        disciplines: disciplineIds,
        cwas: cwaIds,
      })
      .then((res: any) => {
        setBufferSuitabilityEvaluationData(res);
        setBufferSuitabilityEvaluationLoading(false);
      })
      .catch(() => {
        message.error('Buffer Suitability Evaluation Data Error');
      });

    APIList.getPathSuitabilityEvaluation()
      .post({
        optimizationIds,
        disciplines: disciplineIds,
        cwas: cwaIds,
      })
      .then((res: any) => {
        setPathSuitabilityEvaluationData(res);
        setPathSuitabilityEvaluationLoading(false);
      })
      .catch(() => {
        message.error('Path Suitability Evaluation Data Error');
      });

    APIList.getStrategyMatrixCategory()
      .post({
        optimizationIds,
        disciplines: disciplineIds,
        cwas: cwaIds,
      })
      .then((res: any) => {
        setStrategyMatrixCategoryData(res);
        setStrategyMatrixCategoryLoading(false);
      })
      .catch(() => {
        message.error('Strategy Matrix Category Data Error');
      });

    APIList.getStrategyMatrixDistribution()
      .post({
        optimizationIds,
        disciplines: disciplineIds,
        cwas: cwaIds,
      })
      .then((res: any) => {
        setStrategyMatrixDistributionData(res);
        setStrategyMatrixDistributionLoading(false);
      })
      .catch(() => {
        message.error('Strategy Matrix Distribution Data Error');
      });

    APIList.getTimelineDiscipline()
      .post({
        optimizationIds,
        disciplines: disciplineIds,
      })
      .then((res: any) => {
        setTimelineDisciplineData(res);
        setTimelineDisciplineLoading(false);
      })
      .catch(() => {
        message.error('Timeline Discipline Data Error');
      });

    APIList.getWorkfrontManagement()
      .post({
        projectId,
        optimizationIds,
        optimizeId,
      })
      .then((res: any) => {
        setWorkfrontManagementData(res);
      })
      .catch(() => {
        message.error('Workfront Management Data Error');
      })
      .finally(() => {
        setWorkfrontManagementLoading(false);
      });
  };

  const updateTaskScheduleInfo = useCallback(
    async (request, callback) => {
      try {
        setAlertShow(true);
        const updateResult = await APIList.updateTaskScheduleInfo().put(request);
        const jobStatus = await APIList.getJobStatus().post({ jobId: updateResult.jobId });
        if (jobStatus.status === 1) {
          const intervalHandler = setInterval(async () => {
            const jobStatus = await APIList.getJobStatus().post({ jobId: updateResult.jobId });
            if (jobStatus.status !== 1) {
              clearInterval(intervalHandler);
              await APIList.updateOptimizeAdjustedFlag().post({
                optimizationId: request.optimizationId,
                adjustedFlag: 1,
              });
              setAlertShow(false);
              message.success('Reschedule Finished.');
              onFilterData();
              callback();
            }
          }, 5000);
        }
      } catch (err) {
        console.log(err);
      }
    },
    [onFilterData],
  );

  const optimizationAction = useCallback((optimizationId) => {
    const updateAdjustedFlag = APIList.updateOptimizeAdjustedFlag().post({
      optimizationId,
      adjustedFlag: 1,
    });
    updateAdjustedFlag
      .then((res) => {
        // 跳转到 plan 画面，进行 plan 选择
        navigate('/aipskd/plan', { state: { optimizationId } });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (globalEvent.eventType === CHAT_EVENT.MOVE_TO_TASK) {
      alertAction({ title: globalEvent.data });
    }
  }, [globalEvent, ganttLoading]);

  useEffect(() => {
    // Chart reset 事件
    if (globalEvent && globalEvent.eventType === ECHART_EVENT.CHART_ITEM_SELECTED) {
      let activityIds = [];
      let parentId = '';
      if (globalEvent.chartTitle.value === 'Buffer Suitability Evaluation') {
        if (!bufferSuitabilityEvaluationData || bufferSuitabilityEvaluationData.length === 0) {
          return;
        }
        const selectedBufferData = bufferSuitabilityEvaluationData[0].find((item) => item.id === globalEvent.value[3]);
        if (!selectedBufferData) {
          return;
        }
        parentId = selectedBufferData.bufferId;
        activityIds = selectedBufferData.activityIds;
        setTaskListTitle('Activities - Buffer Suitability');
      } else if (globalEvent.chartTitle.value === 'Path Suitability Evaluation') {
        if (!pathSuitabilityEvaluationData || pathSuitabilityEvaluationData.length === 0) {
          return;
        }
        const selectedPathData = pathSuitabilityEvaluationData[0].find((item) => item.id === globalEvent.value[3]);
        if (!selectedPathData) {
          return;
        }
        parentId = selectedPathData.pathId;
        activityIds = selectedPathData.activityIds;
        setTaskListTitle('Activities - Path Suitability');
      } else if (globalEvent.chartTitle.value === 'Strategy Matrix Distribution') {
        if (!strategyMatrixDistributionData || strategyMatrixDistributionData.length === 0) {
          return;
        }
        const selectedDistributionData = strategyMatrixDistributionData[0].data.find((item) => item.id === globalEvent.value[3]);
        if (!selectedDistributionData) {
          return;
        }
        activityIds = [selectedDistributionData.wp];
        setTaskListTitle('Activities - Strategy Matrix');
      }
      setTaskListLoading(true);
      if (parentId) {
        setSelectedTasks([
          {
            key: parentId,
            title: parentId,
            selectable: false,
            children: activityIds.map((id) => ({
              key: id,
              title: id,
              link: alertAction,
            })),
          },
        ]);
      } else {
        setSelectedTasks(
          activityIds.map((id) => ({
            key: id,
            title: id,
            link: alertAction,
          })),
        );
      }

      setTaskListCollapsed(false);

      setTimeout(() => {
        setTaskListLoading(false);
      }, 500);

      globalEvent.eventType = null;
    }
  }, [globalEvent, pathSuitabilityEvaluationData, bufferSuitabilityEvaluationData, strategyMatrixDistributionData]);

  const getStartAndEndDates = (period) => {
    const [startDate, endDate] = period.split('~');
    return {
      start: startDate,
      end: endDate,
    };
  };

  useEffect(() => {
    if (optimizationData) {
      getAlerts(optimizationData.optimizationId);
    }
  }, [memoSearchValue]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (!alertTaskCollapsed) {
      setTaskListCollapsed(true);
    }
    if (alertTaskCollapsed && taskListCollapsed) {
      setMenuCollapsed(false);
    } else {
      setMenuCollapsed(true);
    }
  }, [alertTaskCollapsed]);

  useEffect(() => {
    if (taskListCollapsed) {
      setSelectedTasks([]);
    } else {
      setAlertTaskCollapsed(true);
    }
    if (alertTaskCollapsed && taskListCollapsed) {
      setMenuCollapsed(false);
    } else {
      setMenuCollapsed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskListCollapsed]);

  useEffect(() => {
    if (!peakFilteredData) {
      return;
    }
    setPeakData(peakFilteredData);
  }, [peakFilteredData]);

  useEffect(() => {
    setEvmAxis(kpiRangeData.find((item) => item.kpiName === 'Evm'));
    setTimelineDisciplineAxis(kpiRangeData.find((item) => item.kpiName === 'TimelineDiscipline'));
    setStrategyMatrixDistributionAxis(kpiRangeData.find((item) => item.kpiName === 'StrategyMatrixDistribution'));
    setBufferSuitabilityEvaluationAxis(kpiRangeData.find((item) => item.kpiName === 'BufferSuitabilityEvaluation'));
    setPathSuitabilityEvaluationAxis(kpiRangeData.find((item) => item.kpiName === 'PathSuitabilityEvaluation'));
  }, [kpiRangeData]);

  useEffect(() => {
    setDeadline(project ? project.endDate : '2023-02-13');
  }, [project]);

  const tabChange = (tab) => {
    setCurrentTab(tab);
    if ((tab = 'S&R')) {
      modeDispatch({ type: 'table-mp' });
    }
  };

  const [accumulation, setAccumulation] = useState('areaName');

  useEffect(() => {
    setPeakFilteredData(filterPeakData());
  }, [accumulation]);

  const filterPeakData = () => {
    const originData = peakOriginData.map((data) => ({
      ...data,
      seriesName: data[accumulation],
    }));
    return originData;
  };

  // const getViewMode = () => (headerCollapsed ? 'table-only' : 'chart-table');

  const widget = (
    <>
      <div
        style={{
          display: 'inline-block',
          position: 'absolute',
          left: 40,
          textAlign: 'left',
          zIndex: 100,
        }}
      >
        <div
          style={{
            display: 'inline-block',
            textAlign: 'left',
          }}
        >
          <span style={{ paddingRight: 12 }}>{t('aipskd.optionDetail.peakTarget')}</span>
          <Select
            value={accumulation}
            style={{ width: 220 }}
            onChange={(value) => {
              setAccumulation(value);
            }}
            options={[
              {
                value: 'areaName',
                label: 'CWA',
              },
              {
                value: 'disciplineName',
                label: 'Discipline',
              },
              {
                value: 'subDisciplineName',
                label: 'Sub-Discipline',
              },
              {
                value: 'importance',
                label: 'Importance(1-9)',
              },
              {
                value: 'category',
                label: 'Importance Category(H,M,L)',
              },
            ]}
          />
        </div>
      </div>
    </>
  );

  const ganttMpWidget = (
    <div
      style={{
        display: 'inline-block',
        position: 'absolute',
        left: 40,
        textAlign: 'left',
        zIndex: 100,
      }}
    >
      <div
        style={{
          display: 'inline-block',
          textAlign: 'left',
        }}
      >
        <span style={{ paddingRight: 12 }}>{t('aipskd.optionDetail.peakTarget')}</span>
        <Select
          value={accumulation}
          style={{ width: 400 }}
          onChange={(value) => {
            setAccumulation(value);
          }}
          options={[
            {
              value: 'areaName',
              label: 'CWA',
            },
            {
              value: 'disciplineName',
              label: 'Discipline',
            },
            {
              value: 'subDisciplineName',
              label: 'Sub-Discipline',
            },
            {
              value: 'importance',
              label: 'Importance(1-9)',
            },
            {
              value: 'category',
              label: 'Importance Category(H,M,L)',
            },
          ]}
        />
      </div>
    </div>
  );

  const saveActiveTask = (taskNodeIds) => {
    setGanttLoading(true);
    return APIList.setActiveTask()
      .post({
        optimizationId: optimizationData.optimizationId,
        taskNodeIds,
      })
      .then(() => {
        setGanttLoading(false);
        message.success('Save Success');
      });
  };

  const [activeGanttRef, setActiveGanttRef] = useState(ganttRef);
  useEffect(() => {
    if (currentTab === 'schedule') {
      setActiveGanttRef(ganttRef);
    }
    if (currentTab === 'S&R') {
      setActiveGanttRef(ganttMpRef);
    }
  }, [currentTab]);
  const {
    SaveFilterModalContent,
    LoadFilterModalContent,
    openLoadFilterModal,
    openSaveFilterModal,
    saveModalVisible,
    setSaveModalVisible,
    loadModalVisible,
    setLoadModalVisible,
    handleSaveFilterConfig,
  } = useGanttFilter(activeGanttRef, dataSection?.optimizationId);

  return (
    <>
      {contextHolder}
      <AlertTaskContext.Provider
        value={{
          alertTaskCollapsed,
          setAlertTaskCollapsed,
          taskListCollapsed,
          setTaskListCollapsed,
          alertView,
          setAlertView,
        }}
      >
        {alertShow && <Alert message="現在リスケジューリング中のため、スケジュールが更新できません。" type="warning" banner />}
        <DataSwitcher
          title={t('aipskd.optionDetail.optionDetail')}
          multiple={false}
          readonly={false}
          optimizationSelected={optimizationData}
          collapsed={alertTaskCollapsed && taskListCollapsed}
          extraClickMethod={() => {
            // 根据甘特图的操作历史记录长度来判断是否需要弹窗
            // 如果不需要弹窗，则需要重置一下历史记录清空的状态
            const history = ganttRef.current.getOperateHistory().history;
            if (history.length) {
              setConfirmShow(true);
            } else {
              setClearHistory(true);
            }
          }}
        >
          <ChartTableLayout viewMode={mode.layoutViewMode}>
            <ChartTableLayout.Chart>
              <div
                className="card border"
                style={{
                  height: chartHeight + 40,
                  padding: 0,
                  width: '100%',
                }}
              >
                <div>
                  <BasicInfoCard optimizationData={optimizationData} />
                  <ChartGroup
                    height={chartHeight}
                    loading={chartLoading}
                    isScrollChart
                    isSmallMode
                    syncScroll
                    sizeMode={sizeMode}
                    menuCollapsed={menuCollapsed}
                    scrollCount={scrollCount}
                    setScrollCount={setScrollCount}
                    selectorTop={selectorTop}
                  >
                    <ChartGroup.Item>
                      <EvmChart data={kpiRoticData[0]} loading={kpiRoticLoading} axis={evmAxis} />
                    </ChartGroup.Item>
                    <ChartGroup.Item>
                      <TimelineDisciplineChart
                        loading={timelineDisciplineLoading}
                        data={timelineDisciplineData[0]}
                        deadline={deadline}
                        axis={timelineDisciplineAxis}
                      />
                    </ChartGroup.Item>

                    <ChartGroup.Item>
                      <StrategyMatrixCategoryChart loading={strategyMatrixCategoryLoading} data={strategyMatrixCategoryData[0]} />
                    </ChartGroup.Item>

                    <ChartGroup.Item>
                      <StrategyMatrixDistributionChart
                        loading={strategyMatrixDistributionLoading}
                        uuid={optimizationData ? optimizationData.optimizationId : 1}
                        data={strategyMatrixDistributionData[0]}
                      />
                    </ChartGroup.Item>
                    <ChartGroup.Item>
                      <BufferSuitabilityEvaluationChart
                        loading={bufferSuitabilityEvaluationLoading}
                        data={bufferSuitabilityEvaluationData[0]}
                        axis={bufferSuitabilityEvaluationAxis}
                      />
                    </ChartGroup.Item>
                    <ChartGroup.Item>
                      <PathSuitabilityEvaluationChart
                        loading={pathSuitabilityEvaluationLoading}
                        data={pathSuitabilityEvaluationData[0]}
                        axis={pathSuitabilityEvaluationAxis}
                      />
                    </ChartGroup.Item>
                    <ChartGroup.Item>
                      <WorkfrontManagement loading={workfrontManagementLoading} data={workfrontManagementData} />
                    </ChartGroup.Item>
                  </ChartGroup>
                </div>
              </div>
            </ChartTableLayout.Chart>
            <ChartTableLayout.Table>
              <div
                style={{
                  paddingTop: 4,
                  width: '100%',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    right: 30,
                    zIndex: 10,
                  }}
                >
                  <Badge
                    showZero
                    offset={[0, 6]}
                    size="small"
                    count={alertCount}
                    style={{
                      backgroundColor: color.errorColor,
                    }}
                  >
                    <Tooltip title={t('aipskd.optionDetail.alert')}>
                      <AlertOutlined
                        onClick={() => {
                          setAlertTaskCollapsed(!alertTaskCollapsed);
                        }}
                        className="view-detail-icon"
                        style={{
                          top: 4,
                          marginLeft: 20,
                          paddingRight: 10,
                          color: color.primaryColor,
                        }}
                      />
                    </Tooltip>
                  </Badge>

                  <DoubleRightOutlined
                    className="view-detail-icon"
                    style={{
                      top: 6,
                      marginLeft: 20,
                      marginBottom: 2,
                      color: color.primaryColor,
                      transform: !mode.headerCollapsed ? 'rotate(-90deg)' : 'rotate(90deg)',
                      transition: 'all 0.2s',
                    }}
                    onClick={() => {
                      modeDispatch({
                        type: 'collapsed',
                        value: !mode.headerCollapsed,
                      });
                    }}
                  />
                </div>
                <Tabs
                  activeKey={currentTab}
                  type="card"
                  onChange={tabChange}
                  items={[
                    {
                      key: 'schedule',
                      label: 'Schedule',
                      children: (
                        <div
                          style={{
                            minHeight: tableHeightMap[mode.viewMode],
                            transform: 'rotate(360deg)',
                          }}
                        >
                          {ganttData ? (
                            <GanttChart
                              height={tableHeightMap[mode.viewMode]}
                              data={ganttData}
                              setData={setGanttDataForNewTag}
                              modeOperate={[mode, modeDispatch]}
                              saveActiveTask={saveActiveTask}
                              optimize={optimazeData}
                              optimizationId={optimizationData?.optimizationId}
                              isMasterOptimization={optimizationData?.isMaster}
                              calenderOrg={calenderOrg}
                              updateTaskScheduleInfo={updateTaskScheduleInfo}
                              optimizationAction={optimizationAction}
                              ref={ganttRef}
                              openSaveFilterModal={openSaveFilterModal}
                              openLoadFilterModal={openLoadFilterModal}
                            />
                          ) : (
                            <></>
                          )}
                          {ganttLoading ? <Loading /> : <></>}
                        </div>
                      ),
                    },
                    {
                      key: 'peak',
                      label: 'MP Peak',
                      children: (
                        <div
                          style={{
                            minHeight: tableHeightMap[mode.viewMode],
                            transform: 'rotate(360deg)',
                          }}
                        >
                          <div style={{ display: peakLoading ? 'none' : 'block' }}>
                            {widget}
                            <DateFilteredBarChart
                              accumulation={accumulation}
                              data={peakData}
                              chartOption={chartOption}
                              styles={{
                                height: tableHeightMap[mode.viewMode] - 30,
                              }}
                              dateFilterOption={{
                                position: 'right',
                              }}
                              area={area}
                              resourceLoadingConstraint={resourceLoadingConstraint}
                              resourceType={resourceType}
                              optimizationData={optimizationData}
                            />
                          </div>
                          {peakLoading ? <Loading /> : <></>}
                        </div>
                      ),
                    },
                    {
                      key: 'critical',
                      label: 'Critical Chain',
                      children: (
                        <div
                          style={{
                            minHeight: tableHeightMap[mode.viewMode],
                            transform: 'rotate(360deg)',
                          }}
                        >
                          {taskSensitivityData ? (
                            <CriticalChain
                              height={tableHeightMap[mode.viewMode]}
                              data={taskSensitivityData}
                              optimizationId={optimizationData?.optimizationId}
                            />
                          ) : (
                            <></>
                          )}
                          {taskSensitivityLoading ? <Loading /> : <></>}
                        </div>
                      ),
                    },
                    {
                      key: 'S&R',
                      label: 'Schedule & Resources',
                      children: (
                        <div
                          style={{
                            minHeight: maxHeight + 300,
                            transform: 'rotate(360deg)',
                          }}
                        >
                          {ganttData && peakData ? (
                            <div ref={exportContainerRef} id="chart-table-layout">
                              <GanttChartWithMp
                                exportImg={handleExport}
                                exportPDF={handleExportPDF}
                                height={maxHeight}
                                data={ganttDataForNewTag}
                                modeOperate={[mode, modeDispatch]}
                                optimizationId={optimizationData?.optimizationId}
                                calenderOrg={calenderOrg}
                                accumulation={accumulation}
                                peakData={peakData}
                                chartOption={chartOption}
                                widget={ganttMpWidget}
                                saveActiveTask={saveActiveTask}
                                setData={setGanttData}
                                area={area}
                                resourceLoadingConstraint={resourceLoadingConstraint}
                                resourceType={resourceType}
                                optimizationData={optimizationData}
                                ref={ganttMpRef}
                                openSaveFilterModal={openSaveFilterModal}
                                openLoadFilterModal={openLoadFilterModal}
                              />
                            </div>
                          ) : (
                            <></>
                          )}
                          {ganttLoading || peakLoading ? <Loading /> : <></>}
                        </div>
                      ),
                    },
                  ]}
                ></Tabs>
              </div>
            </ChartTableLayout.Table>
          </ChartTableLayout>
        </DataSwitcher>
        <TaskAlert
          styles={{
            top: tableTop,
            height: '100%',
            width: tableWidth,
          }}
          acceptableItems={acceptableItems}
          notAcceptableItems={notAcceptableItems}
          optimizationId={optimizationData?.optimizationId}
          loading={memoLoading}
        />

        <TaskList
          title={taskListTitle}
          styles={{
            top: tableTop,
            height: '100%',
            width: tableWidth,
          }}
          items={selectedTasks}
          loading={taskListLoading}
        />
        <Modal
          title="Confirm"
          open={confirmShow}
          onOk={() => {
            // 子组件需要清空操作历史，并重置历史记录状态
            ganttRef.current.clearHistory();
            setConfirmShow(false);
            setClearHistory(true);
          }}
          onCancel={() => {
            setConfirmShow(false);
          }}
        >
          You will lost your operations. Are you sure to continue?
        </Modal>
        <Modal
          title="Save Filter Configuration"
          open={saveModalVisible}
          onCancel={() => setSaveModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setSaveModalVisible(false)}>
              Cancel
            </Button>,
            <Button key="save" type="primary" onClick={handleSaveFilterConfig}>
              Save
            </Button>,
          ]}
          width={400}
        >
          <SaveFilterModalContent />
        </Modal>
        <Modal title="Filter Configuration" open={loadModalVisible} onCancel={() => setLoadModalVisible(false)} footer={null} width={800}>
          <LoadFilterModalContent />
        </Modal>
      </AlertTaskContext.Provider>
    </>
  );
};

export default PlanOptionDetailPage;
